import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import ResponsiveAppBar from './ResponsiveAppBar';
import {Outlet} from "react-router-dom";
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';
import { Typography } from '@mui/material';

let theme = createTheme();
theme = responsiveFontSizes(theme);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <CssBaseline />
        <ResponsiveAppBar />
        <main>
          <Outlet />
        </main>
        <footer>
          <Typography sx={{marginTop: "2rem"}}variant="body1">© 2023-2024 Developed by Me</Typography>
          <Typography variant="body2">Michael C.</Typography>
        </footer>
      </div>
    </ThemeProvider>
  );
}

export default App;